module.exports = __webpack_public_path__ + "static/isaac-e3af7fe3ed79a76eda7dc1ec88c4a892.png";